import React from 'react'

const Steps = () => {
    const stepsData = [
        {
            id: 'ONE',
            title: "Reserve your Hideout",
            subtitle: "Hideouts are first come, first serve. Secure your place in line with a $1,000 deposit."
        },
        {
            id: 'TWO',
            title: "We deliver anywhere.",
            subtitle: "Our units are built on wheels, we're able to easily delivery anywhere in the United States."
        },
        {
            id: 'THREE',
            title: "Profit.",
            subtitle: "Your Hideout can easily pay for itself via short term rentals. Let's start your glamping empire."
        }
    ];
    
    return (
        <section className="flex flex-col items-center py-12 lg:py-16 mb-4 lg:mb-24">
            <div className="text-center mb-8">
                <h1 className="text-[28px] md:text-[36px] font-semibold text-[#000] leading-[100%] mb-20">Get Yours in 3 Simple Steps</h1>
            </div>
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-12">
                {stepsData.map((work, index) => (
                    <div key={index} className="flex flex-col items-center text-center gap-4">
                        <p className='font-semibold uppercase'>Step {" "} {work.id}</p>
                        <h3 className="text-[18px] md:text-xl font-semibold text-[#1b1b1b]">{work.title}</h3>
                        <p className="mt-2 text-[15px] md:text-[16px] font-light">{work.subtitle}</p>
                    </div>
                ))}
                </div>
            </div>
        </section>
    )
}

export default Steps